import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiSlider: {
      styleOverrides: {
        root: {
          color: '#0A8BC7',
        },
        thumb: {
          backgroundColor: '#0A8BC7',
          '&:hover': {
            backgroundColor: '#0A8BC7',
            boxShadow: '0 0 0 8px rgba(13, 133, 189, 0.16)',
          },
        },
        track: {
          backgroundColor: '#0A8BC7',
        },
        rail: {
          backgroundColor: '#e0e0e0',
        },
        valueLabel: {
          backgroundColor: '#0A8BC7',
        },
      },
    },
  },
});

export default theme;
